import { Route, Routes, Navigate } from "react-router-dom";

import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";

import { Land } from "@pages/public/Home";
import { Home } from "@pages/auth/Home";
import { Auth } from "@pages/public/Auth";
import { Account } from "@pages/auth/account/Account";
import { InfrastructureList } from "@pages/auth/infrastructure/List";
import { PlatformHealthList } from "@pages/auth/platformHealth/List";
import { PlatformHealth } from "@pages/auth/platformHealth/Platform";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes with PublicRoute wrapper */}
      <Route element={<PublicRoute />}>
        <Route path="/" element={<Land />} />
        <Route path="/login" element={<Auth />} />
      </Route>

      {/* Protected Routes with ProtectedRoute wrapper */}
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<Home />} />
        <Route path="/account" element={<Account />} />

        {/* Infrastructure Area */}
        <Route path="/infrastructure/list" element={<InfrastructureList />} />

        {/* Platform Health Area */}
        <Route path="/platformHealth/:id" element={<PlatformHealth />} />
        <Route path="/platformHealth/list" element={<PlatformHealthList />} />
      </Route>

      {/* Fallback - redirect any not identified routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
